import React from 'react';
import './domain-search-loading-elements.scss';

/**
 * Renders a fake search result indicating the ongoing search the desired amount of times.
 */
export const DomainSearchLoadingElements = (props) => (
  <ul className="domain-list">
    {Array.from({ length: props.nrOfElements }, (_, index) => (
      <li className="domain-list__item" key={index}>
        <a className="domain-list__link domain-list__link--load">
          <span className="shimmer shimmer--overline" />
          <span className="shimmer shimmer--title" />
        </a>
      </li>
    ))}
  </ul>
);

export default DomainSearchLoadingElements;
